<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds confirmation"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    Changing type of <span class="font-semibold">{{ data.attribute?.name }}</span> attribute will
    make the following references to be invalid.
  </div>

  <div class="flx-modal-body">
    <flx-attribute-references
      [isCollapsed]="false"
      [isCollapsable]="false"
      [references]="data.references"
      [path]="data.attribute.name"
      [resourceType]="data.resourceType"
    />
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
        type="button"
        data-testId="confirmation-modal-cancel-button"
      >
        Cancel
      </button>
      <button
        (click)="confirm()"
        class="flx-ds primary danger"
        flxButton
        type="button"
        data-testId="confirmation-modal-confirm-button"
      >
        Proceed
      </button>
    </div>
  </div>
</flx-modal>
